import React from 'react';

import classes from './OneColumnLayout.module.scss';

interface OneColumnLayoutProps {
    header?: React.ReactNode;
    children?: React.ReactNode;
}

export const OneColumnLayout: React.FC<OneColumnLayoutProps> = props => {
    return (
        <div className={classes.root}>
            {props.header}

            <div className={classes.content}>{props.children}</div>
        </div>
    );
};
